import { useMutation, useQueryClient } from 'react-query'
import { useSnackbar } from 'notistack'
import { deleteBanner } from 'services/cm-api/delete-banner'

/**
 * Wraps `DELETE /banner/:id`. Unlike customer-group delete there is
 * no 409 branch — banners aren't referenced by any other row. We
 * surface 404 / 5xx through `onError` as a generic error snackbar.
 */
export function useDeleteBanner() {
  const queryClient = useQueryClient()
  const { enqueueSnackbar } = useSnackbar()

  return useMutation(deleteBanner, {
    onSuccess: async (response) => {
      if (response.success === true) {
        enqueueSnackbar('Banner deleted', { variant: 'success' })
        await queryClient.invalidateQueries(['getBanners'])
      }
    },
    onError: (err: unknown) => {
      const axiosErr = err as {
        response?: { data?: { error?: { message?: string } } }
      }
      const apiMessage = axiosErr?.response?.data?.error?.message
      enqueueSnackbar(apiMessage ?? 'Failed to delete banner', {
        variant: 'error',
      })
      console.error('deleteBanner failed: ', err)
    },
  })
}
